<nav [@animateMenu] class="navbar main-navbar on-top" [class.nav-shadow]='this.pageYPosition>0'>
    <div class="container">
        <a   (click)='scroll("banner")'>
            <img src='assets/images/logo_transparent.png' width='100' />
        </a>
        <ul ngbNav #nav="ngbNav" class="menu-ul">
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("about")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item1" | translate}}</span></a>
                <ng-template ngbNavContent>First content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("researchareas")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item2" | translate}}</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("people")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item3" | translate}}</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("projects")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item4" | translate}}</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("publications")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item5" | translate}}</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("theses")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item6" | translate}}</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("contact")'><span class='nav-number'> </span> <span class="underline nav-text"> {{"Header.Item7" | translate}}</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li>
                <div ngbDropdown class="d-inline-block">
                    <div class="language-container" id="dropdownForm1" ngbDropdownToggle>
                        <img *ngIf='languageFormControl.value == "en"' width="20px" src="/assets/icons/en_flag.png" alt="English">
                        <span *ngIf='languageFormControl.value == "en"' class="flag-text">English</span>

                        <img *ngIf='languageFormControl.value == "tr"' width="20px" src="/assets/icons/tr_flag.jpg" alt="Türkçe">
                        <span *ngIf='languageFormControl.value == "tr"' class="flag-text">Türkçe</span>
                        <svg class='arrow-language' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                    </div>
                    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                        <div (click)='changeLanguage("tr")' style='border-bottom-left-radius: 0px !important;border-bottom-right-radius: 0px !important;' class="language-container language-container-selector active" [class.active]='languageFormControl.value == "tr"'>
                            <img width="20px" src="/assets/icons/tr_flag.jpg" alt="Türkçe">
                            <span class="flag-text">Türkçe</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 arrow-active" viewBox="0 0 16 16">
                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                              </svg>
                        </div>
                        <div (click)='changeLanguage("en")' style="margin-top: 1px !important; border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;" class="language-container language-container-selector" [class.active]='languageFormControl.value == "en"'>
                            <img width="20px" src="/assets/icons/en_flag.png" alt="English">
                            <span class="flag-text">English</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 arrow-active" viewBox="0 0 16 16">
                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div class="menu-wrapper">
            <div [class.animate]='responsiveMenuVisible' (click)='responsiveMenuVisible = !responsiveMenuVisible' class="hamburger-menu"></div>
        </div>
        <div class="menu-responsive" [ngStyle]="{'pointer-events': !responsiveMenuVisible ? 'none' : '' }">
            <aside [class.aside-show]='responsiveMenuVisible' [class.nav-shadow]='this.pageYPosition>0' class="on-top">
                <nav>
                    <ol>
                        <li>
                            <a (click)='scroll("about")'>
                                {{"Header.Item1" | translate}}
                            </a>
                        </li>
                        <li>
                            <a (click)='scroll("researchareas")'>
                                {{"Header.Item2" | translate}}
                            </a>
                        </li>
                        <li>
                          <a (click)='scroll("people")'>
                              {{"Header.Item3" | translate}}
                          </a>
                      </li>
                      <li>
                        <a (click)='scroll("projects")'>
                            {{"Header.Item4" | translate}}
                        </a>
                      </li>
                      <li>
                        <a (click)='scroll("publications")'>
                            {{"Header.Item5" | translate}}
                        </a>
                      </li>
                      <li>
                        <a (click)='scroll("theses")'>
                            {{"Header.Item6" | translate}}
                        </a>
                      </li>
                      <li>
                        <a (click)='scroll("contact")'>
                            {{"Header.Item7" | translate}}
                        </a>
                      </li>
                      <li>
                            <div class="language-container">
                                <div (click)='changeLanguage("tr")' style='border-bottom-left-radius: 0px !important;border-bottom-right-radius: 0px !important;' class="language-container language-container-selector active" [class.active]='languageFormControl.value == "tr"'>
                                    <img src="/assets/icons/tr_flag.jpg" alt="Türkçe">
                                    <span class="flag-text">Türkçe</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 arrow-active" viewBox="0 0 16 16">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                      </svg>
                                </div>
                                <div (click)='changeLanguage("en")' style="margin-top: 1px !important; border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;" class="language-container language-container-selector" [class.active]='languageFormControl.value == "en"'>
                                    <img src="https://www.worldometers.info/img/flags/us-flag.gif" alt="English">
                                    <span class="flag-text">English</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 arrow-active" viewBox="0 0 16 16">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </div>
                            </div>
                      </li>
                    </ol>
                </nav>
            </aside>
        </div>
    </div>
</nav>
